import React, { useState, cloneElement } from "react";
import {
  Show,
  List,
  TabbedShowLayout,
  Tab,
  Datagrid,
  EditButton,
  TextField,
  ImageField,
  ReferenceField,
  ReferenceManyField,
  DateField,
  TopToolbar,
  RefreshButton,
  ListButton,
  BooleanField,
  EmailField,
  NumberField,
  Button,
  Link,
  useRecordContext,
  useResourceContext,
  ArrayField,
  Responsive,
  ShowController,
  ShowView,
  SimpleShowLayout,
  useGetOne
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import FileCopyIcon from "@mui/icons-material//FileCopy";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import { useNavigate, useLocation } from "react-router-dom";

const CustomEditButton = (dataFromProps) => {
  const navigate = useNavigate();
  const resource = useResourceContext();
  console.log("custom show", dataFromProps, resource);
  return (
    <div>
      <EditButton />
    </div>
  );
};

const ShowActions = (props) => {
  const navigate = useNavigate();
  const resource = useResourceContext();
  const record = useRecordContext();
  // const { data } = useGetOne("businesses", { id: record?.id });

  console.log("jjjjjjjjjjjjjjjjjjj", record, resource);
  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [modalDupShow, setModalDupShow] = useState(false);
  const [modalDupMsg, setModalDupMsg] = useState(
    "Are you sure you want to duplicate the scheme ?"
  );
  const [customFilterUrl, setCustomFilterUrl] = useState(
    `voucher_scheme_id=${record?.id}`
  );
  const dataFromProps = record;

  console.log("rajjaaaa ji ", dataFromProps);

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log(
      "...",
      window.location.href,
      `${apiUrl}/${record?.resource}_csv`
    );
    options.method = "GET";
    let _url = window.location.href.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");

      setCustomFilterUrl(_url[1], () => {
        fetch(`${apiUrl}/${record?.resource}_csv?${customFilterUrl}`, options)
          .then((res) => {
            return res.json();
          })
          .then((jsonD) => {
            console.log("json= inside callback", jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : "";
            Swal.fire({
              html: msg,
              icon: "success",
            });
            //   this.setState({ modalShow: true});
            //   this.setState({ modalMsg: msg});
          });
      });
    } else {
      setCustomFilterUrl(`voucher_scheme_id=${record?.id}`);
      fetch(
        `${apiUrl}/${resource}_csv?${`voucher_scheme_id=${record?.id}`}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });
    }
  };
  // exporterModal = () => {
  //   return "";
  // };

  const onDupClose = () => {
    setModalDupShow(false);
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
    basePath,
    // resource
  } = props;
  const csvResource = resource + "_csv";

  const onDuplicate = () => {
    console.log(" onDuplicate in ");
    let splitSchemeName = dataFromProps.scheme_name.split(" ");
    const copySchemeName =
      splitSchemeName[0] == "Copy"
        ? dataFromProps.scheme_name
        : "Copy " + dataFromProps.scheme_name;
    let dataToSend = {
      scheme_name: copySchemeName,
      no_of_coupons: dataFromProps.no_of_coupons,
      start_datetime: dataFromProps.start_datetime,
      end_datetime: dataFromProps.end_datetime,
      discount_type: dataFromProps.discount_type,
      discount_value: dataFromProps.discount_value,
      is_finalized: false,
      status: true,
      discount_scheme_conditions: dataFromProps.discount_scheme_conditions,
      discount_scheme_type: dataFromProps.discount_scheme_type,
      coupon_code: "Copy_" + dataFromProps.coupon_code.replace(/ /g, ''),
    };

    console.log("duppppppppppppppppppp", dataToSend);

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "POST";
    options.body = JSON.stringify(dataToSend);
    fetch(`${apiUrl}/discount_schemes`, options)
    .then((res) => {
      if (res.ok) return res.json();
      return res.json().then(res => {
        throw new Error(res.errors.status)
      })
    })
      .then((json) => {
        if (json) {
          console.log("json reply", json, props);
          // setTimeout(()=>{
          Swal.fire({
            html: "Scheme duplicated successfully",
            icon: "success",
          }).then((result) => {
            // navigate(`/discount_schemes`,{state: json.id})
            navigate(`/discount_schemes/${json.id}/show`);
          });
          // props.history.push(
          //     {
          //       pathname: `/discount_schemes`,
          //       state: json.id
          //      });
          // },500)
        }
      }).catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error,
        });
      });
  };

  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}

        <div>
          <button
            className="ds-button"
            // onClick={()=>setModalDupShow(!modalDupShow)}
            onClick={() => {
              Swal.fire({
                text: modalDupMsg,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Yes",
                denyButtonText: "No",
              }).then((result) => {
                if (result.isConfirmed) {
                  onDuplicate();
                } else if (result.isDenied) {
                  Swal.fire("Changes are not saved", "", "info");
                }
              });
            }}
          >
            {<FileCopyIcon />}
            <span>Duplicate Scheme</span>
          </button>
        </div>
        {dataFromProps && dataFromProps.is_finalized && dataFromProps.discount_scheme_type =='dynamic' && (
          <Link to={`/discount_scheme_assignment/${record.id}`}>
            <div className="export-button">
              {<BeenhereIcon />}
              <span>Assign Vouchers</span>
            </div>
          </Link>
        )}
        {/* {
          dataFromProps && dataFromProps.is_finalized &&
          <div>
            <button
              className="export-button"
              component={Link}
              to={ `/discount_scheme_assignment/${props.id}`}
            >
              {<BeenhereIcon />}
              <span>Assign Vouchers</span> 
            </button>
          </div>
        } */}
        <RefreshButton />
        <ListButton />
        <CustomEditButton dataFromProps={dataFromProps} />
        {/* <ExportButton
          onClick={(e) => this.callExport(e)}
          disabled={total === 0}
          resource={csvResource}
          sort={currentSort}
          filter={{ ...filterValues, ...permanentFilter }}
          exporter={this.exporterModal}
          maxResults={maxResults}
          /> */}
        {dataFromProps && dataFromProps.is_finalized && (
          <div>
            <button
              className="export-button"
              onClick={(e) => callExport(e)}
              disabled={total === 0}
              sort={currentSort}
              filter={{ ...filterValues, ...permanentFilter }}
            >
              {<GetAppIcon />}
              <span>{"Export"}</span>
            </button>
          </div>
        )}
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
      {/* {modalDupShow && (
        <Modal open={modalDupShow} onClose={onDupClose} center>
          <h3>{modalDupMsg}</h3>
          <Button
          className="resend-button"
          onClick={onDuplicate}
        >
          <span>Duplicate</span> 
        </Button>
        </Modal>
      )} */}
    </React.Fragment>
  );
};

// const ShowActions = ({ basePath, data, id }) => (
//   <TopToolbar>
//     <RefreshButton />
//     <ListButton basePath={basePath} />
//     <CustomEditButton basePath={basePath} id={id} record={data} />
//   </TopToolbar>
// );

const ShowTitle = ({ record }) => {
  return record && <span>Discount Scheme {record.first_name}</span>;
};

const capitalizeEachWord = (str) => {
  const words = str.replace(/_/g, " ").split(" ").slice(1);
  const capitalizedWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return capitalizedWords.join(" ");
};

const DiscountSchemeConditionField = () => {
  const record = useRecordContext();
  console.log("jjjjjjjjjjjjjjjjjjjjjjjjjjjjj", record);
  return (
    <>
      {record.discount_scheme_conditions && (
        <>
          <div className="show-page-label">Discount scheme conditions</div>
          <ul className="dsc-list">
            {record.discount_scheme_conditions.map((item) => {
              return (
                <li className="show-page-value" key={item.condition_type}>
                  {capitalizeEachWord(item.condition_type)}
                  {item.condition_type == "by_quantity" && `(Bags)`}
                  {item.condition_type == "by_sales_amount" && `(PHP)`}
                  &nbsp;-&nbsp;
                  {typeof item?.condition_value == "string" &&
                  item?.condition_value !== null ? (
                    <span
                      className="show-page-value"
                      key={item.condition_value}
                    >
                      {item.condition_value}
                    </span>
                  ) : (
                    item?.condition_value !== null &&
                    item.condition_value.map((i) => (
                      <>
                        <span className="show-page-value" key={i.label}>
                          {i.label}
                        </span>
                        {/* <span key={i.value}>{i.value}</span> */}
                      </>
                    ))
                  )}
                </li>
              );
            })}
          </ul>
        </>
      )}
    </>
  );
};

const DiscountSchemesShow = ({ permissions, ...props }) => {
  const navigate = useNavigate();
  const resource = useResourceContext();
  const record = useRecordContext();

  console.log("props ==>", props, record, resource);
  const { id } = props;
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const discountSchemeShowId = pathSplit[2];

  const { data } = useGetOne("discount_schemes", { id: discountSchemeShowId });
  const disType = data?.discount_scheme_type

  const soldToLabel = disType == 'static' ? 'Sold To List' : "Coupon Assigned Sold To List"

  const showAllOrders = getLocalStorageKey("show_all_orders");
  return (
    <Show
      actions={<ShowActions permissions={permissions} />}
      {...props}
      title={<ShowTitle />}
    >
      <TabbedShowLayout Class="tab-scroll">
        <Tab label="Scheme Detail" contentClassName="scrollTab">
        <ShowController {...props}>
              {(controllerProps) => {
                const disStype = controllerProps.record.discount_scheme_type;

                return (
                  <ShowView
                    {...props}
                    actions={<></>}
                    {...controllerProps}
                    title=" "
                  >
                    <SimpleShowLayout className="simpleLayoutCustom">
                      <TextField source="scheme_name" />
                      <TextField source="discount_scheme_type" />
                      {
                        disStype == 'static' ? <TextField source="coupon_code" allowEmpty />:
                        <TextField source="no_of_coupons" allowEmpty />

                      } 
                      <DateField
                        showTime
                        source="start_datetime"
                        label="Start Date Time"
                        allowEmpty
                      />
                      <DateField
                        showTime
                        source="end_datetime"
                        label="End Date Time"
                        allowEmpty
                      />
                      <TextField source="status" />
                      <TextField source="discount_type" />
                      <TextField source="discount_value" />
                      <TextField source="total_used_voucher" />
                      
                      {
                        disStype == 'dynamic' &&
                        <TextField source="total_assigned_voucher" />
                      }
                      {
                        disStype == 'dynamic' &&
                        <TextField source="total_unused_voucher" />
                      }
                      {
                        disStype == 'dynamic' &&
                        <TextField source="total_unassigned_voucher" />
                      }
                      <TextField source="is_finalized" />
                      <DiscountSchemeConditionField className="dsc-field" />
                    </SimpleShowLayout>
                  </ShowView>
                );
              }}
            </ShowController>
        </Tab>
        <Tab 
        label={soldToLabel}
        >
          <ReferenceManyField
            addLabel={false}
            reference="voucher_assigend_list"
            target="id"
            className="tab-pagination"
          >
            <List
              {...props}
              filterDefaultValues={{ id: discountSchemeShowId }}
              exporter={false}
              actions={false}
            >
              <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                <TextField source="business_name" />
                {/* <TextField source='total_unassigned_voucher' /> */}
                <TextField source="business_sap_code" />
                <TextField source="discount_voucher" />
                <TextField source="is_used" />
                <ReferenceField
                  label="Order Number"
                  source="sap_digital_order_id"
                  reference="sap_digital_orders"
                  link="show"
                  allowEmpty
                >
                  <TextField source="order_number" />
                </ReferenceField>
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default DiscountSchemesShow;
